import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_CLAIMS_SUMMARY_LIST_REQUEST,
  GET_CLAIMS_SUMMARY_LIST_SUCCESS,
  GET_CLAIMS_SUMMARY_LIST_FAILURE,
  GET_CLAIM_DETAIL_REQUEST,
  GET_CLAIM_DETAIL_SUCCESS,
  GET_CLAIM_DETAIL_FAILURE,
  CLAIMS_LOAD,
} from '../constants';
import { api } from '../services';
import {
  enrichClaim,
  parseClaimsListResponse,
  parseClaimDetailResponse,
} from '../utils/claimsUtils';

function* getClaimsSummaryListResult(action) {
  try {
    const result = yield call(api.getClaimsSummaryList, action.payload);

    if (result.data && result.status === 200) {
      const claimsList = parseClaimsListResponse(result.data);
      const enrichedClaims = claimsList.map(enrichClaim);
      yield put({ type: GET_CLAIMS_SUMMARY_LIST_SUCCESS, payload: enrichedClaims });
    } else if (result?.response?.status === 404) {
      yield put({ type: GET_CLAIMS_SUMMARY_LIST_SUCCESS, payload: [] });
    } else {
      const message = result?.response?.data?.resultDescription
        || result?.data?.error?.message
        || 'Failed to load claims.';
      yield put({ type: GET_CLAIMS_SUMMARY_LIST_FAILURE, payload: message });
    }
  } catch (error) {
    yield put({ type: GET_CLAIMS_SUMMARY_LIST_FAILURE, payload: 'Failed to load claims.' });
  }
}

function* getClaimDetailResult(action) {
  try {
    const { selectedClaim, ...requestPayload } = action.payload;
    const result = yield call(api.getClaimDetail, requestPayload);

    if (result.data && result.status === 200) {
      const claimDetail = parseClaimDetailResponse(result.data);
      yield put({
        type: GET_CLAIM_DETAIL_SUCCESS,
        payload: claimDetail,
      });
    } else {
      const message = result?.response?.data?.resultDescription
        || result?.data?.error?.message
        || 'Failed to load claim detail.';
      yield put({ type: GET_CLAIM_DETAIL_FAILURE, payload: message });
    }
  } catch (error) {
    yield put({ type: GET_CLAIM_DETAIL_FAILURE, payload: 'Failed to load claim detail.' });
  }
}

function* claimsLoadResult(action) {
  yield put({ type: GET_CLAIMS_SUMMARY_LIST_REQUEST, payload: action.payload });
}

export function* claimsWatcherSaga() {
  yield takeLatest(CLAIMS_LOAD, claimsLoadResult);
  yield takeLatest(GET_CLAIMS_SUMMARY_LIST_REQUEST, getClaimsSummaryListResult);
  yield takeLatest(GET_CLAIM_DETAIL_REQUEST, getClaimDetailResult);
}
